export default __webpack_public_path__ + "static/media/Kosalan Might.0e0eeee7.jpg";